<template>
  <el-tooltip :content="label" effect="light" placement="top" :disabled="disabled || loading">
    <span class="use-icon-button" v-bind="$attrs" :class="{ disabled, loading }" @click="handleClick">
      <i v-if="loading" class="el-icon-loading loading-icon"></i>
      <img v-else :src="iconSrc" :alt="label" draggable="false" />
    </span>
  </el-tooltip>
</template>

<script>
import iconMap from '@/utils/icon-loader'
export default {
  name: 'IconButton',
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: Boolean,
    loading: Boolean
  },
  computed: {
    iconSrc () {
      if (this.src.includes('/') || this.src.includes('.')) {
        return this.src
      }
      return iconMap[this.src]
    }
  },
  methods: {
    handleClick () {
      if (this.disabled || this.loading) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.use-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.use-icon-button img {
  width: 24px;
  height: 24px;
}

.loading-icon {
  font-size: 20px;
  animation: spin 1s linear infinite;
}

.use-icon-button.disabled,
.use-icon-button.loading {
  cursor: not-allowed;
  opacity: 0.5;
}

.use-icon-button:not(.disabled):not(.loading):hover img {
  filter: brightness(1.1);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
